import axios from 'axios';

// ── Batas waktu request ──────────────────────────────────────────────
// Dipasang per-request di interceptor, BUKAN satu angka untuk semuanya.
//
// 15 detik tetap jadi patokan umum dan SENGAJA tidak dinaikkan menyeluruh:
// layar kerja (Front Desk) lebih baik gagal cepat dan diulang daripada petugas
// berdiri satu menit di depan member menunggu request yang tidak akan sampai.
//
// Tapi laporan & dashboard mengaduk buku besar SETAHUN penuh. Di data yang sudah
// tebal satu panggilan bisa 8-15 detik, dan makin panjang seiring jurnal
// bertambah — mepet sekali dengan batas 15 detik. Sekali lewat, halamannya gagal
// muat dan (dulu) isinya ikut hilang. Jadi yang berat dikasih jatah sendiri.
const TIMEOUT_BIASA = 15000;
const TIMEOUT_BERAT = 60000;

// GET yang menghitung ulang dari buku besar / absensi satu periode penuh.
// Tambahkan ke sini kalau ada endpoint laporan baru yang berat.
// Cermin LAPORAN_BERAT di public/service-worker.js — endpoint berat WAJIB
// terdaftar di DUA tempat, kalau tidak yang satu memberi batas waktu panjang
// sementara yang lain tetap menyimpannya di cache (atau sebaliknya).
const GET_BERAT = [
  /^\/reports\//,
  /^\/admin\/reports\//,
  /^\/kpi\//,
  /^\/hr\/dashboard/,
  /^\/admin\/branches\/all-detail/,
  /^\/admin\/transaksi-pelanggan/,
  /^\/admin\/customers-umum\//,
  // Bayar Gaji / Bayar Komisi: pt-month-status menghitung ulang payroll tiap bulan
  // yang belum dibayar — 18-22 dtk untuk PT 7 cabang (12 Okt 2026, data prod),
  // lewat batas 15 dtk sehingga badge bulan hilang. Pratinjaunya 2 dtk sendirian,
  // 15 dtk kalau barengan — layarnya kini memuat pratinjau dulu.
  /^\/commission-payments\/pt-(preview|month-status)/,
  // Checklist Tutup Buku mengevaluasi seluruh item bulan itu: 3-6 dtk sekarang,
  // tumbuh bersama data.
  /^\/tutup-buku/,
];

const berat = (config) => (config.method || 'get').toLowerCase() === 'get' && GET_BERAT.some((p) => p.test(config.url || ''));

// Build produksi SELALU '/api' (nginx yang meneruskan) — tidak bergantung pada
// berkas .env.production, yang tidak pernah ada di repo (.env.* di-gitignore):
// 26 Okt 2026 build pertama di droplet menembak http://localhost:5002/api dari
// browser pengunjung, login gagal tanpa satu pun request sampai ke server.
// Cadangan dev HANYA menyala kalau frontend/.env.development.local hilang.
// Angkanya WAJIB 5002: 5000/5001 itu backend Bersihin/Pixel yang jalan
// berbarengan di laptop ini, dan menembak ke sana tidak memunculkan error apa
// pun — cuma data perusahaan lain yang tampil seolah-olah milik Fast Track.
export const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5002/api');

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  // Cek localStorage dulu (remember me), lalu sessionStorage
  const token = localStorage.getItem('ft_token') || sessionStorage.getItem('ft_session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Timeout yang ditulis sendiri di pemanggilnya menang; sisanya ikut aturan di atas.
  if (!config.timeout) config.timeout = berat(config) ? TIMEOUT_BERAT : TIMEOUT_BIASA;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Jangan auto-redirect kalau 401-nya dari endpoint login sendiri —
      // biarkan caller (LoginPage) yang nampilin error message tanpa reload.
      const url = err.config?.url || '';
      const isLoginRequest = url.includes('/auth/login');

      if (!isLoginRequest) {
        localStorage.removeItem('ft_token');
        localStorage.removeItem('ft_user');
        sessionStorage.removeItem('ft_session_token');
        sessionStorage.removeItem('ft_session_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  },
);

export default api;
